import { QueryParamsProvider as MadkomQueryParamsProvider } from "@madkom/query-params";
import { useHistory, useLocation } from "react-router-dom";

import { IChildrenProp } from "../types/IChildrenProp";

interface IProps extends IChildrenProp {}

const QueryParamsProvider = ({ children }: IProps) => {
  const location = useLocation();
  const history = useHistory();
  return (
    <MadkomQueryParamsProvider history={history} location={location}>
      {children}
    </MadkomQueryParamsProvider>
  );
};

export { QueryParamsProvider };
